import React, { useState, useEffect } from "react";
import "../../assets/css/ProfileDetails.css";
import PrimaryButton from "../../components/common/PrimaryButton";
import SecondaryButton from "../../components/common/SecondaryButton";
import ReusableTextField from "../../components/common/ReusableTextField";
import shapeSet from "../../assets/images/Shape Set.png";
import cameraIcon from "../../assets/images/Camera.png";
import UserService from "../../services/UserService";

export default function ProfileDetails() {
  const [profileImage, setProfileImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    whatsAppNo: "",
    businessDetails: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await UserService.fetchUserProfile();
        console.log("User_Response", response);

        if (response.data?.success && response.data.data) {
          const userDetails = response.data.data;

          setUserData({
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            email: userDetails.email,
            whatsAppNo: userDetails.whatsAppNo,
            businessDetails: userDetails.businessDetails,
          });
          // If backend gives profile image, load preview
          if (userDetails.profilePic) {
            setPreviewImage(userDetails.profilePic);
          }

        } else {
          console.error("API did not return expected data format");
        }
      } catch (error) {
        console.error("Error fetching profile details:", error);
      }
    })();
  }, []);

  const handleImageUpload = (e) => {
  if (e.target.files && e.target.files[0]) {
    const file = e.target.files[0];

    // Allowed file types
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG or WEBP images are allowed.");
      return;
    }

    // Validate file size (max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert("Image size must be less than 5MB.");
      return;
    }

    // Save file + show preview
    setProfileImage(file);
    setPreviewImage(URL.createObjectURL(file));
  }
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setProfileImage(null);
    alert("Changes canceled!");
  };

  const handleSave = async () => {
    try {
      const response = await UserService.updateUserProfile(
        userData,
        profileImage
      );
      console.log("Profile updated successfully:", response.data);
      alert("Profile updated successfully!");

      const refreshed = await UserService.fetchUserProfile();

      if (refreshed.data?.success) {
        setUserData(refreshed.data.data);

        if (refreshed.data.data.profileImage) {
          setPreviewImage(refreshed.data.data.profileImage);
        }
      }
    } catch (error) {
      console.error("Response:", error.response?.data);
      alert(
        `Failed to update profile. ${
          error.response?.data?.message || error.message || "Please try again."
        }`
      );
    }
  };

  return (
    <>
      <div className="profile-container">
        <main className="profile-main">
          <div className="profile-content">
            
            {/* Profile Picture Section */}
            <div className="profile-picture">
              {/* Display preview or fallback image */}
              <img
                src={previewImage ? previewImage : shapeSet}
                alt="Profile Preview"
                className="profile-shape"
              />

              {/* Hidden File Input */}
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                style={{ display: "none" }}
              />

              {/* Camera Icon */}
              <label htmlFor="fileInput">
                <img
                  src={cameraIcon}
                  alt="Camera Icon"
                  className="camera-icon"
                  style={{ cursor: "pointer" }}
                />
              </label>
            </div>

            {/* Profile Form */}
            <form className="profile-form" onSubmit={(e) => e.preventDefault()}>
              <ReusableTextField
                name="firstName"
                label="First Name"
                required
                placeholder="Enter your first name"
                value={userData.firstName}
                onChange={handleInputChange}
              />

              <ReusableTextField
                name="lastName"
                label="Last Name"
                required
                placeholder="Enter your last name"
                value={userData.lastName}
                onChange={handleInputChange}
              />

              <ReusableTextField
                name="email"
                type="email"
                label="Email"
                required
                placeholder="Enter your email"
                value={userData.email}
                readOnly
                disabled
              />

              <ReusableTextField
                name="whatsAppNo"
                label="WhatsApp Number"
                required
                placeholder="Enter your WhatsApp number"
                value={userData.whatsAppNo}
                readOnly
                disabled
              />

              <ReusableTextField
                name="businessDetails"
                label="Company Details"
                placeholder="Enter your company details"
                value={userData.businessDetails}
                onChange={handleInputChange}
                disabled
                readOnly
              />

              {/* Buttons */}
              <div className="buttons">
                <SecondaryButton onClick={handleCancel}>Cancel</SecondaryButton>
                <PrimaryButton onClick={handleSave}>Save</PrimaryButton>
              </div>
            </form>
          </div>
        </main>
      </div>
    </>
  );
}
